import React from 'react';
import PropTypes from 'prop-types';
import cx from '@/utils/cx';
import useStyle from './style';

const Link = ({
  className,
  children,
  _text_color,
  ...rest
}) => {
  const classes = useStyle({ _text_color });

  return (
    <a
      className={cx(className, classes.link)}
      {...rest}
    >
      {children}
    </a>
  );
};

Link.propTypes = {
  _text_color: PropTypes.string,
};

Link.defaultProps = {
  _text_color: 'primary2',
};

export default Link;
